import { dashboardMeetings } from '@/modules/meeting/store/meeting.state';
import { MeetingCollection } from '@/modules/meeting/models/MeetingCollection';

export function getDashboardMeetings(): MeetingCollection {
  return dashboardMeetings.value;
}
